"use client";
import { IPageChangeModel } from "@/common/table/AppPagination";
import { useAppDispatch } from "@/redux-store";
import { commonActions } from "@/redux-store/common.slice";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

const useHandlePageChange = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const dispatch = useAppDispatch();
  const handlePageChange = (newValue: IPageChangeModel) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("take", newValue.pageSize.toString());
    const skip = (newValue.currentPage - 1) * newValue.pageSize;
    params.set("skip", skip.toString());
    const url = `${params.toString()}`;
    router.push(pathname + "?" + url);
    // dispatch(commonActions.handleSetLoadingTable(true));
  };
  return handlePageChange;
};

export default useHandlePageChange;
